import axios from "axios";
import i18n from "../locales/i18n";

export const customSpringAxios = axios.create({
    baseURL: process.env.REACT_APP_SPRING_API || "https://api-lw64c4rxja-lm.a.run.app/api/bussoft",
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: false,
});

customSpringAxios.interceptors.request.use(
    async (config) => {
        return config;
    },
    (error) => {
        return Promise.reject(error);
    },
);


customSpringAxios.interceptors.response.use(
    (response) => response,
    async (error) => {
        // Otkazane zahteve (debounce/cancel na pretrazi) propuštamo bez prevođenja u poruku
        if (axios.isCancel(error) || error?.code === "ERR_CANCELED") {
            return Promise.reject(error);
        }
        return Promise.reject(
            (error.response && error.response.data) ||
            i18n.t("serverError", "Došlo je do greške. Pokušajte ponovo.")
        );
    },
);
